import baseStyles from './base'
import inkStyles from './ink'

export default {
  base: baseStyles,
  ink: inkStyles,
}
